import { API_PREFIX } from "./constant";
import { Request } from "./request";

// 列表
export interface DoctorAuditEntriesParams {
  doctorId?: any;
  variety?: any;
  startDate?: any;
  endDate?: any;
  mergeFlag?: any
  size?: any,
  current?: any
}

export function getDoctorAuditEntries(
  params: DoctorAuditEntriesParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dentalLedger/list`,
    method: "GET",
    params,
  };
}

// 详情
export interface DoctorAuditEntriesDetailParams {
  id?: any;
}

export function getDoctorAuditEntriesDetail(
  params: DoctorAuditEntriesDetailParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dentalLedger/detail`,
    method: "GET",
    params,
  };
}

// 保存
export interface DentalLedgerSubmitParams {
  id?: any;
  doctorId?: any;
  doctorName?: any;
  externalProcessId?: any;
  orderNo?: any;
  patientId?: any;
  processItemDisease?: any;
  processItemTooth?: any;
  processProvider?: any;
  processStartTime?: any;
  registrationCertificateNo?: any;
}

export function dentalLedgerSubmit(
  params: DentalLedgerSubmitParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dentalLedger/submit`,
    method: "POST",
    body: params,
  };
}


// 关联外加工
export interface DentalLedgerProcessListParams {
  current?: any;
  size?: any;
  endDate?: any;
  startDate?: any;
  keyWord?: any;
}

export function dentalLedgerProcessList(
  params: DentalLedgerProcessListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dentalLedger/processList`,
    method: "GET",
    params,
  };
}


// 外加工详情
export interface DentalLedgerProcessDetailParams {
  processItemId?: any;
}

export function dentalLedgerProcessDetail(
  params: DentalLedgerProcessDetailParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dentalLedger/processDetail`,
    method: "GET",
    params,
  };
}

// 删除
export interface DentalLedgerDeleteParams {
  id?: any;
}

export function dentalLedgerDelete(
  params: DentalLedgerDeleteParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dentalLedger/delete`,
    method: "GET",
    params,
  };
}


// 导出
export function getDoctorAuditEntriesListExport(
  params: DoctorAuditEntriesParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/dentalLedger/export`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}
